export const formatCurrency = (value, minimumFractionDigits = 0) => {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);
};

export const formatNumber = (value, minimumFractionDigits = 0, maximumFractionDigits = 2) => {
  return new Intl.NumberFormat("en-AU", {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(Number(value) || 0);
};

export const formatPercent = (value, minimumFractionDigits = 0, maximumFractionDigits = 2) => {
  return `${formatNumber(value, minimumFractionDigits, maximumFractionDigits)}%`;
};